import { Box, Stack } from '@mui/material';
import type { Provider } from '@repo/api-gw-sdk';

import { CloudProviderIndicator } from '@/components/cloudProviderIndicator';
import { SidePanelPropsTable } from '@/components/panels/instance/tabs/shared';

export const JobSummaryContentWrapper = ({
  cloudProvider,
  fields,
}: {
  cloudProvider?: Provider;
  fields: {
    id: string;
    title: string;
    group: string | undefined;
    Component: React.ReactNode;
  }[];
}) => {
  return (
    <Stack direction='row' gap='40px'>
      <Box width='160px'>
        {cloudProvider && (
          <CloudProviderIndicator cloudProvider={cloudProvider} />
        )}
      </Box>
      <SidePanelPropsTable>
        <tbody>
          {fields.map((field) => (
            <tr key={field.id}>
              <td className='props-col'>{field.title}</td>
              <td className='break-all'>{field.Component}</td>
            </tr>
          ))}
        </tbody>
      </SidePanelPropsTable>
    </Stack>
  );
};
